import React from 'react'
import Coffee from "../dist/webImages/coffee.svg"
import calendar from "../dist/webImages/calendar.svg"
import clock from "../dist/webImages/wall-clock.svg"
import phonecall from "../dist/webImages/phone-call.svg"
import noimg from '../dist/webImages/no_image.jpg'
import dayjs from 'dayjs';
import swal from 'sweetalert';
import useDelete from '../customHooks/useDelete';
import { toast } from 'react-toastify';




const truncateText = (text, maxLength) => {
    if(text) {
      if (text.length <= maxLength) {
        return text;
      }
      return text.slice(0, maxLength) + '...';
    }
    return text;
  };
const BookingsCard = ({data,modelDataUpdate,modelStatusUpdate,alldata,deleted,showDelete=false}) => {
    const {id,beverage,client_phone,booking_status,meeting_purpose,client_name,client_email,meeting_date,consultant_image,consultant_name,consultant_designation,number_of_attendees,time_slot,meeting_type} = data
    const [resDelete, apiMethodDelete] = useDelete();
    const handleDelete = (e) => {
      e.stopPropagation();
      swal({
        title: "Are you sure?",
        text: "Are you sure that you want to delete?",
        buttons: true,
        icon: "warning",
        dangerMode: true,
      })
        .then(willDelete => {
          if (willDelete) {
            swal("Successfully Delete", "", "success");
            apiMethodDelete(`booking/delete/${id}`)
          }
        });
    };
    React.useEffect(() => {
      if(resDelete.data) {
        const {message, status} = resDelete.data
        if (status !== "false" && alldata && deleted && showDelete) {
          const update = alldata.filter((item) => item.id !== id)
          deleted(update)
        }
        if (status === "false") {
          toast.error(message);
        } else {
          toast.success(message);
        }
      }
    }, [resDelete.data])

    const handleOpenModel = () => {
        modelStatusUpdate(true)
        modelDataUpdate(data)
    }

    const formattedDate = dayjs(meeting_date).format('MMMM D, YYYY');
    const maxLength = 50;
    const truncatedText = truncateText(meeting_purpose, maxLength);
    const maxLength2 = 15;
    const truncatedText2 = truncateText(client_name, maxLength2);

  return (
    <div className="bookingBox cursor-pointer bg-[#EFF4FD] p-5 rounded-xl relative" onClick={handleOpenModel}>
      {showDelete && (
      <div className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem] top-[-0.5rem] right-[-0.5rem] grid place-items-center rounded-[.7rem] z-10' onClick={handleDelete}>
        <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      )}
                <ul className='list'>
                    <li className='flex items-center justify-between gap-2'>
                        <div className='h2 text-[1.3rem] font-Mluvka flex items-center gap-1 leading-[1]'> <span className='bg-primary p-1 text-[1rem] rounded-xl'>#{id}</span> {truncatedText2}</div> 
                        {
                         booking_status === "completed" ?
                        <span className='p-2 text-white rounded-[.5rem] bg-[green] text-[.8rem]'>Completed</span>
                        :
                        booking_status === "cancelled" ?
                        <span className='p-2 text-white rounded-[.5rem] bg-[red] text-[.8rem]'>Cancelled</span>
                        :
                        <span className='p-2 text-white rounded-[.5rem] bg-[#B7903B] text-[.8rem]'>Pending</span>
                       }
                    </li>
                </ul>
                <div className="h3 mb-3">{client_email}</div>
                        {/* <div className='flex items-center gap-1'><img src={Coffee} alt="Coffee" /><span className='font-Mluvka text-[.8rem]'>{beverage}</span></div> */}
                      

                <div className='calender my-4 flex items-center gap-2'>
                    <img src={calendar} className='w-[1.5rem]' alt="calender" />
                    <span className='font-MluvkaBold text-[.9rem]'>{formattedDate}</span>
                </div>
                <div className='calender my-4 flex items-center gap-2'>
                    <img src={clock} className='w-[1.5rem]' alt="calender" />
                    <span className='font-MluvkaBold text-[.9rem]'>{time_slot}</span>
                </div>
                <div className='calender my-4 flex items-center gap-2'>
                    <img src={phonecall} className='w-[1.5rem]' alt="calender" />
                    <span className='font-MluvkaBold text-[.9rem]'>{client_phone}</span>
                </div>

                {/* <div className='evening mb-4'>
                    <div className="h4 font-MluvkaBold mb-2">Number of Person</div>
                    <ul className='list flex items-center gap-3'>
                        <li className='flex items-center gap-2 bg-white py-3 px-5 rounded-full'>
                            <svg className="svg-icon w-[1rem] fill-[#B7903B]" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M78.22291438 968.30107625c0 14.21935406 9.47956969 23.69892375 23.69892374 23.69892375s23.69892375-9.47956969 23.69892375-23.69892375c0-213.33036656 173.03552063-386.36588719 386.36588625-386.36588625s386.37923813 173.03552063 386.37923907 386.36588625c0 14.21935406 9.47956969 23.69892375 23.69892281 23.69892375s23.69892375-9.47956969 23.69892375-23.69892375c0-196.74779531-132.74067469-362.66696344-310.51597969-417.19451437 90.06926062-45.03463031 151.713165-137.52051375 151.713165-244.14564282C786.96091906 155.261105 663.69981406 32 511.98664813 32S237.03908094 155.261105 237.03908094 306.96091906c0 106.66518281 61.6305525 199.1110125 151.69981406 244.14564281C208.60037281 603.25754469 78.22291438 769.17671281 78.22291438 968.30107625z m206.22736499-663.75678c0-125.62432219 101.92539844-227.56307156 227.54972063-227.56307156s227.56307156 101.99215594 227.56307156 227.56307156S637.651025 532.1474225 512 532.1474225s-227.54972063-101.92539844-227.54972063-227.60312625z m0 0" fill="" /></svg>
                            <span className=' text-[.8rem] font-MluvkaBold'>{number_of_attendees}</span></li>
                    </ul>
                </div> */}
                
                {meeting_type && (
                <div className='evening mb-4'>
                    <div className="h4 text-[.8rem] font-MluvkaBold mb-1">Meeting Type</div>
                    <ul className='list h-[4rem] flex items-center gap-3'>
                        <li className='flex items-center gap-2 bg-white py-1 px-5 rounded-lg'>
                            <p>{meeting_type}</p>
                        </li>
                    </ul>
                </div>
                )}

                <div className='evening mb-4'>
                    <div className="h4 text-[.8rem] font-MluvkaBold mb-1">Purpose Of Meeting</div>
                    <ul className='list h-[4rem] flex items-center gap-3'>
                        <li className='flex items-center gap-2 bg-white py-1 px-5 rounded-lg'>
                            <p>{truncatedText}</p>
                        </li>
                    </ul>
                </div>
               
             {consultant_name &&       <>
                <div className='Lawyer my-4 flex items-center gap-2 '>
                    <span className='text-[#95ACD5] font-Mluvka text-[.8rem]'>Team</span>
                    <div className='w-full h-[.1rem] bg-[#C9D4E9]'></div>
                </div>

                <div className='bookingprofile flex items-center gap-3'>
                    <div className="bookingprofile__img  grid place-items-center bg-[#C9D3E4] rounded-xl">
                        <img src={consultant_image} onError={(e) => { e.target.src = noimg }} className='rounded-lg w-[3.375rem] h-[3.375rem] object-cover' alt="bookingProfile" />
                    </div>
                    <div className="bookingprofile__txt">
                        <div className="h5 font-Mluvka capitalize leading-[1] mb-1">{consultant_name}</div>
                        <div className="h4 text-[.8rem]">{consultant_designation}</div>
                    </div>
                </div>
                    </>}
            </div>
  )
}

export default BookingsCard
